export const IN_FLIGHT_MATCH_WINDOW_MS = 10000;

export const findNewAnnotationIDs = ({ previousData = {}, nextData = {} }) => {
  const previousKeys = new Set(Object.keys(previousData ?? {}));

  return Object.keys(nextData ?? {}).filter((key) => !previousKeys.has(key));
};

export const findMatchingInFlightClientID = ({
  serverAnnotation,
  inFlightSends = new Map(),
  matchWindowMs = IN_FLIGHT_MATCH_WINDOW_MS,
}) => {
  if (!serverAnnotation || inFlightSends.size === 0) return null;

  const serverText = serverAnnotation.text?.trim() ?? "";
  const serverUserID = serverAnnotation.userID;
  const serverCreationTime = serverAnnotation.creationTime || 0;

  let oldestMatch = null;
  let oldestCreationTime = Infinity;

  for (const [clientID, flight] of inFlightSends.entries()) {
    if (flight.userID !== serverUserID) continue;
    if (flight.text !== serverText) continue;

    const timeDelta = Math.abs(serverCreationTime - flight.creationTime);
    if (timeDelta > matchWindowMs) continue;

    if (flight.creationTime < oldestCreationTime) {
      oldestCreationTime = flight.creationTime;
      oldestMatch = clientID;
    }
  }

  return oldestMatch;
};

export const resolveInFlightClientIDs = ({
  previousData = {},
  nextData = {},
  inFlightSends = new Map(),
  matchWindowMs = IN_FLIGHT_MATCH_WINDOW_MS,
}) => {
  const newIDs = findNewAnnotationIDs({ previousData, nextData });
  const resolvedClientIDs = [];
  const usedClientIDs = new Set();

  newIDs.forEach((annotationID) => {
    const serverAnnotation = nextData?.[annotationID];
    if (!serverAnnotation) return;

    const remainingSends = new Map(
      [...inFlightSends.entries()].filter(
        ([clientID]) => !usedClientIDs.has(clientID)
      )
    );

    const clientID = findMatchingInFlightClientID({
      serverAnnotation,
      inFlightSends: remainingSends,
      matchWindowMs,
    });

    if (!clientID) return;

    resolvedClientIDs.push(clientID);
    usedClientIDs.add(clientID);
  });

  return resolvedClientIDs;
};
